import { useQuery } from '@tanstack/react-query';
import { classApi } from '../lib/api';

export function useClasses() {
  return useQuery({
    queryKey: ['classes'],
    queryFn: async () => {
      const res = await classApi.getClasses();
      return res.data;
    },
  });
}

export function useSubjects(classId?: number) {
  return useQuery({
    queryKey: ['subjects', classId],
    queryFn: async () => {
      if (!classId) return [];
      const res = await classApi.getSubjects(classId);
      return res.data;
    },
    enabled: !!classId,
  });
}

export function useChapters(subjectId?: number) {
  return useQuery({
    queryKey: ['chapters', subjectId],
    queryFn: async () => {
      if (!subjectId) return [];
      const res = await classApi.getChapters(subjectId);
      return res.data;
    },
    enabled: !!subjectId,
  });
}
